import StoreMarketingMeta from './StoreMarketingMeta';

export default StoreMarketingMeta;
